import ImageRenderer from "@/components/common/ImageRenderer";
import { twMerge } from "tailwind-merge";

export type Logo = {
  name: string;
  logo: string;
  className?: string;
};

export function LogoCloud({ logos, className }: { logos: Logo[], className: string }) {
  return (
    <div className={twMerge("pb-24 sm:pb-32", className)}>
      <div className="mx-auto px-6 lg:px-8">
        <div
          className="mx-auto grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
          {logos.map(({ name, logo }, i: number) =>
            <ImageRenderer key={name} name={logo} index={i} width={158} height={48}
                           className="col-span-2 max-h-12 w-full object-contain lg:col-span-1" />
          )}
        </div>
      </div>
    </div>
  )
}
